module.exports = __webpack_public_path__ + "b18072cbaff43e98a95dc84902ceccbd.pdf";